const DEFAULT_SCROLL_BOTTOM_THRESHOLD = 160;

type FeedbackGalleryScrollMetrics = {
  scrollTop: number;
  clientHeight: number;
  scrollHeight: number;
  threshold?: number;
};

type FeedbackGalleryLoadState = {
  hasNextPage?: boolean;
  isLoading: boolean;
  isFetching: boolean;
  isFetchingNextPage: boolean;
};

type FeedbackGalleryAutoFillState = FeedbackGalleryLoadState & {
  isIntersectionObserverSupported: boolean;
  isInitialLoading: boolean;
  isScrollable: boolean;
  hasAutoFillAttempted: boolean;
};

export const isFeedbackGalleryNearBottom = ({
  scrollTop,
  clientHeight,
  scrollHeight,
  threshold = DEFAULT_SCROLL_BOTTOM_THRESHOLD,
}: FeedbackGalleryScrollMetrics): boolean => {
  return scrollTop + clientHeight >= scrollHeight - threshold;
};

export const canLoadNextFeedbackGalleryPage = ({
  hasNextPage,
  isLoading,
  isFetching,
  isFetchingNextPage,
}: FeedbackGalleryLoadState): boolean => {
  return (
    Boolean(hasNextPage) && !isLoading && !isFetching && !isFetchingNextPage
  );
};

export const shouldAutoFillFeedbackGalleryFallback = ({
  isIntersectionObserverSupported,
  hasAutoFillAttempted,
  isInitialLoading,
  isScrollable,
  ...loadState
}: FeedbackGalleryAutoFillState): boolean => {
  if (isIntersectionObserverSupported) return false;
  if (hasAutoFillAttempted) return false;
  if (isInitialLoading) return false;
  if (isScrollable) return false;

  return canLoadNextFeedbackGalleryPage(loadState);
};

